import { Component, OnInit } from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { InventoryDashboardComponent } from "./inventory-dashboard/inventory-dashboard.component";
import { WorkstationComponent } from "./workstation/workstation.component";
import { NgClass } from "@angular/common";
import { InventoryService } from "src/app/service/inventory.service";
import { filter } from "rxjs";

import { canViewAssetLogs } from "src/app/service/asset-logs.service";

@Component({
    selector: "app-inventory",
    imports: [
        RouterOutlet,
        HeaderComponent,
        InventoryDashboardComponent,
        WorkstationComponent,
        NgClass
    ],
    templateUrl: "./inventory.component.html",
    styleUrl: "./inventory.component.css"
})

export class InventoryComponent implements OnInit {
  showAdminRequest = false;
  canViewAssetLogs = false;
  userDepartment: string | null = null;
  hasAdminRequests: boolean = false;

  isMenuExpanded = false;
  activeMenu: string = 'dashboard';
  activeSubMenu: string = '';

  constructor(
    private router: Router,
    private inventoryService: InventoryService
  ) {}

  ngOnInit() {
    this.userDepartment = localStorage.getItem('department');
    this.showAdminRequest = this.userDepartment === 'ADMIN';
    this.canViewAssetLogs = canViewAssetLogs();

    const savedActiveMenu = localStorage.getItem('activeMenu');
    if (savedActiveMenu) {
      this.activeMenu = savedActiveMenu;
    }

    // notification view
    this.inventoryService.adminRequestCount$.subscribe(count => {
      this.hasAdminRequests = count > 0;
    });

    // Listen to route changes to update activeMenu automatically
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url.includes('/inventory/dashboard')) {
          this.activeMenu = 'dashboard';
        } else if (event.url.includes('/inventory/inventories')) {
          this.activeMenu = 'inventories';
        } else if (event.url.includes('/inventory/workstation')) {
          this.activeMenu = 'workstation';
        } else if (event.url.includes('/inventory/asset-logs')) {
          this.activeMenu = 'asset-logs';
        }
        localStorage.setItem('activeMenu', this.activeMenu);
      });
  }

  onMouseEnter() {
    this.isMenuExpanded = true;
    if (this.activeMenu === 'request' && this.activeSubMenu) {
      this.activeMenu = this.activeSubMenu;
    }
  }

  onMouseLeave() {
    this.isMenuExpanded = false;
    if (this.activeMenu.includes('request')) {
      this.activeSubMenu = this.activeMenu;
      this.activeMenu = 'request';
    }
  }

  navigateTo(menu: string, route: string) {
    this.activeMenu = menu;
    if (menu.includes('request')) {
      this.activeSubMenu = menu;
    }
    localStorage.setItem('activeMenu', menu);
    this.router.navigate([route]);
  }


  isSidebarOpen = false;

toggleSidebar() {
  this.isSidebarOpen = !this.isSidebarOpen;
}

}

